const assetsReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default assetsReducer;